<template>
  <ul class="breadcrumbs flex" :class="{ 'breadcrumbs--light': isLight }">
    <li class="breadcrumbs__item">
      <NuxtLink to="/" class="breadcrumbs__link">
        <NuxtIcon name="IconHome" />
      </NuxtLink>
    </li>

    <li v-for="item in parentSections" :key="`breadcrumbs__${item.slug}`" class="breadcrumbs__item">
      <NuxtLink
        v-if="item.slug"
        :to="{ name: 'home', params: { chapters: useSlugTransform(item.slug) } }"
        class="breadcrumbs__link"
      >
        {{ item.title }}
      </NuxtLink>
    </li>

    <li class="breadcrumbs__item">
      <span class="breadcrumbs__link breadcrumbs__link--current">{{ currentPageName }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ClientBreadcrumbsItem } from '@/types/client/pages';
import './styles.scss';
import { useSlugTransform, useRouter, useRuntimeConfig, computed} from '#imports';
import { useSchemaOrg } from '@unhead/schema-org';

interface Props {
  currentPageName?: string;
  parentSections?: ClientBreadcrumbsItem[];
  isLight?: boolean;
}

const props = defineProps<Props>();

const route = useRouter().currentRoute.value;

const list = computed(() => {
  const items = props.parentSections?.map((el, index) => ({
    "@type": "ListItem",
    position: index + 2,
    name: el.title,
    item: useRuntimeConfig().public.siteUrl + el.slug,
  })) || [];

  return [
    {
      "@type": "ListItem",
      position: 1,
      name: 'Главная',
      item: useRuntimeConfig().public.siteUrl,
    },
    ...items,
    {
      "@type": "ListItem",
      position: items.length + 2,
      name: props.currentPageName,
      item: useRuntimeConfig().public.siteUrl + route.fullPath,
    }
  ];
});

  if (route.params.chapters[0] === 'services' && route.params.chapters.length === 3) {
    useSchemaOrg([
      {
        '@type': 'BreadcrumbList',
          itemListElement: list.value,
        },
    ]);
  }


</script>
